import React from 'react';
import { fetchAudioBlob } from '../../../services/musicAudioService';

export default function usePlayableAudioUrl(sourceUrl) {
  const [state, setState] = React.useState(INITIAL_STATE);

  React.useEffect(() => {
    if (!sourceUrl) {
      setState(INITIAL_STATE);
      return undefined;
    }
    let objectUrl = '';
    let cancelled = false;
    setState({ ...INITIAL_STATE, loading: true });
    fetchAudioBlob(sourceUrl)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = window.URL.createObjectURL(blob);
        setState({ url: objectUrl, loading: false, error: '' });
      })
      .catch((error) => {
        if (!cancelled) setState({ url: '', loading: false, error: error.message });
      });
    return () => {
      cancelled = true;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [sourceUrl]);

  return state;
}

const INITIAL_STATE = {
  url: '',
  loading: false,
  error: '',
};
